import LSButton from 'js/components/LSButton'
import React from 'react'

const EmptyState = () => (
  <div className="o-width-limiter mb-96 mt-48 text-center lg:mb-128 lg:mt-80 lg:pb-64">
    <p className="type-large mb-32 leading-default text-grey-lighter">
      This category is as empty as my fridge after a cheat day.
    </p>
    <LSButton
      link={true}
      size="small"
      variant="secondary"
      href="/nutrition-explained/"
      upperCase
    >
      Other stories
    </LSButton>
  </div>
)

export default EmptyState
